export const LOCALSTORAGEKEYS = {
    USERROLES: 'userRoles',
    SUBROLES: 'subRoles',
    USERPROFILE: 'userProfile',
    USERPERMISSIONS: 'userPermissions',
    NATIONALPERMISSIONS: 'nationalPermissions',
    STATEPERMISSIONS: 'statePermissions',
    DISTRICTPERMISSIONS: 'districtPermissions',
    BLOCKPERMISSIONS: 'blockPermissions',
    APPLICATIONPERMISSIONS: 'applicationPermissions',
    MODULEPERMISSIONS: 'modulePermissions',
    GEOGRAPHY: 'userGeography',
    SELECTED_ROLE: 'selectedRole',
    PROFILE_IMAGE: 'profileImage',
    USER_CLF: 'userClf',
    SELECTED_LANGUAGE: 'selectedLanguage',
    THEME: 'theme',
};
